"use client";
import { cn } from '../../utils/cn'; // Proje yapısına göre güncellendi
import React, { ReactNode } from "react";

interface AuroraBackgroundProps extends React.HTMLProps<HTMLDivElement> {
  children: ReactNode;
  showRadialGradient?: boolean;
}

export const AuroraBackground = ({
  className,
  children,
  showRadialGradient = true,
  ...props
}: AuroraBackgroundProps) => {
  return (
    <div // <main> kaldırıldı
      className={cn(
        "transition-bg relative min-h-screen", // bg-zinc-50 text-slate-950 dark:bg-zinc-900 kaldırıldı
        className,
      )}
      {...props}
    >
      <div // Efekt katmanı
        className="absolute inset-0 overflow-hidden" // -z-10 kaldırıldı
        style={
          {
            "--aurora":
              "repeating-linear-gradient(100deg,#3b82f6_10%,#a5b4fc_15%,#93c5fd_20%,#ddd6fe_25%,#60a5fa_30%)",
            "--dark-gradient":
              "repeating-linear-gradient(100deg,#000_0%,#000_7%,transparent_10%,transparent_12%,#000_16%)",
            "--white-gradient":
              "repeating-linear-gradient(100deg,#fff_0%,#fff_7%,transparent_10%,transparent_12%,#fff_16%)",

            "--blue-300": "#9AC9F0", // Çok Açık Mavi/Eflatun
            "--blue-400": "#50C8E8", // Camgöbeği/Turkuaz
            "--blue-500": "#A770EF", // Parlak Mor
            "--indigo-300": "#B57EDC", // Açık Mor/Lavanta
            "--violet-200": "#60A5FA", // Orta Mavi
            "--black": "#000",
            "--white": "#fff",
            "--transparent": "transparent",
          } as React.CSSProperties
        }
      >
        <div
          //   I'm sorry but this is what peak developer performance looks like // trigger warning
          className={cn(
            `after:animate-aurora pointer-events-none absolute -inset-[10px] [background-image:var(--white-gradient),var(--aurora)] [background-size:300%,_200%] [background-position:50%_50%,50%_50%] opacity-50 blur-[10px] invert filter will-change-transform [--aurora:repeating-linear-gradient(115deg,var(--blue-500)_10%,var(--indigo-300)_15%,var(--blue-300)_20%,var(--violet-200)_25%,var(--blue-400)_30%)] [--dark-gradient:repeating-linear-gradient(115deg,var(--black)_0%,var(--black)_7%,var(--transparent)_10%,var(--transparent)_12%,var(--black)_16%)] [--white-gradient:repeating-linear-gradient(115deg,var(--white)_0%,var(--white)_7%,var(--transparent)_10%,var(--transparent)_12%,var(--white)_16%)] after:absolute after:inset-0 after:[background-image:var(--white-gradient),var(--aurora)] after:[background-size:300%,_200%] after:mix-blend-difference after:content-[""] dark:[background-image:var(--dark-gradient),var(--aurora)] dark:invert-0 after:dark:[background-image:var(--dark-gradient),var(--aurora)]`, // Gradyan açıları 100deg'den 115deg'ye değiştirildi

            showRadialGradient &&
              `[mask-image:radial-gradient(ellipse_at_100%_0%,black_10%,var(--transparent)_70%)]`,
          )}
        ></div>
      </div>
      <div className="relative z-0"> {/* z-index 0'a düşürüldü, header z-40 üstte kalacak */}
        {children}
      </div>
    </div>
  );
};